"use strict";

import angular from "angular";

import _ from "lodash";
import template from "./chart-gauge.component.html";
import "./chart-gauge.component.scss";
import { ChartScoreStructure } from "./chart-score-structure";

("use strict");

class ChartGaugeComponent {
    constructor($element) {
        this.$element = $element;
    }

    $onInit() {
        this._setStructure();
    }

    $onChanges(changes) {
        if (typeof _.get(changes, "pointValue.previousValue") != "object") {
            this._setStructure();
        }
    }

    _setStructure() {
        this.chartStructure = { chart: ChartScoreStructure };

        this.chartStructure.chart.series[0].data = [this.pointValue || 0];

        if (this.chartHeight)
            this.chartStructure.chart.chart.height = this.chartHeight;
        else
            this.chartStructure.chart.chart.height =
                this.$element[0].clientHeight * 2;
    }
}

export { ChartGaugeComponent };

ChartGaugeComponent.$inject = ["$element"];

const name = "chartGaugeComponent";
const def = {
    controller: ChartGaugeComponent,
    bindings: {
        pointValue: "<",
        chartHeight: "@"
    },
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
